import React from "react";
import { useHistory } from "react-router-dom";

import { App } from "../../../../routes/Constants";

import Line from "../../../../assets/icons/line.svg";
import { ReactComponent as ArrowNextWhite } from "../../../../assets/icons/arrowNextWhite.svg";
import {
  verifyUserType,
  verifyUserTypeConnectedRegistrar,
} from "../../../../shared/helpers";
import { registrationCategory } from "../../../../constants/register.constants";

export const ViewPatientsBox = () => {
  const history = useHistory();
  const isPrescriber = verifyUserType(registrationCategory.PRESCRIBER);
  const isConnectedRegistrar = verifyUserTypeConnectedRegistrar(
    registrationCategory.CONNECTED_REGISTRAR
  );

  return (
    <div className="col second">
      <img src={Line} alt="White Line" />
      <div className="main-text font-size-30 bold">
        {isPrescriber || isConnectedRegistrar
          ? "View Patients/Renew PAF"
          : "View Patients"}
      </div>
      <div className="second-text font-size-16">
        {isPrescriber || isConnectedRegistrar
          ? "View existing patients or renew a PAF"
          : "View existing patients"}
      </div>
      <button
        className="primary-button"
        onClick={() => {
          history.push(App.VIEW_PATIENTS);
        }}
      >
        {isPrescriber || isConnectedRegistrar
          ? "View Patients/Renew PAF"
          : "View Patients"}
        <ArrowNextWhite />{" "}
      </button>
    </div>
  );
};
